import React, { FC } from 'react'
import Frame from 'components/Frame'
import styled from 'styled-components'
import fonts from 'const/style/fonts';
import IComponentProps from 'interfaces/IComponentProps';
import imgComplete from 'assets/img/img_complete@2x.png';

const FinalePageFrame=styled(Frame)`
  display:flex;
  flex-direction:column;
  justify-content:center;
  align-items:center;
  line-height:25px;
  ${fonts.H1_White};
  .img-complete {
    width:60px;
    height:60px;
    margin-bottom:30px;
  }
`

const FinalePage: FC<IComponentProps> = (props) => {
  return (
    <FinalePageFrame className='bg'>
      <div>
        <img src={imgComplete} className='img-complete' alt='' />
      </div>
      <div>
      온라인PT 전형 응시가 완료되었습니다.
      </div>
      <div>
      브라우저를 닫고 종료하시면 됩니다.
      </div>
      <div>
        수고 많으셨습니다.
      </div>
    </FinalePageFrame>
  );

}

export default FinalePage;